import {    APPLICATION_UPDATE_DATA,
            APPLICATION_SAVED_DATA_SUCCESS,
            RECEIVE_APPLICATION_SUCCESS,
            APPLICATION_SAVING_DATA,
            REQUEST_UPDATE_APPLICATION_STATUS,
            RECEIVE_UPDATE_APPLICATION_STATUS,
            RECEIVE_UPDATE_APPLICATION_STATUS_ERROR,
            REQUEST_APPLICATION_DETAILS,
            RECEIVE_APPLICATION_DETAILS_SUCCESS,
            RECEIVE_APPLICATION_DETAILS_ERROR,
            REQUEST_APPLICATION_DESCRIPTION,
            RECEIVE_APPLICATION_DESCRIPTION_SUCCESS,
            RECEIVE_APPLICATION_DESCRIPTION_ERROR,
            REQUEST_VALIDATE_EMAIL, 
            RECEIVE_VALIDATE_EMAIL,
            RECEIVE_VALIDATE_EMAIL_ERROR,
            REQUEST_LOAN,
            REQUEST_LOAN_SUCCESS,
            REQUEST_LOAN_ERROR,
            REQUEST_VALIDATE_PHONE,
            RECEIVE_VALIDATE_PHONE,
            RECEIVE_VALIDATE_PHONE_ERROR,
            REQUEST_VALIDATE_EMAIL_CODE, 
            RECEIVE_VALIDATE_EMAIL_CODE,
            RECEIVE_VALIDATE_EMAIL_ERROR_CODE,
            REQUEST_VALIDATE_PHONE_CODE,
            RECEIVE_VALIDATE_PHONE_CODE,
            RECEIVE_VALIDATE_PHONE_ERROR_CODE,
            RECEIVE_LOAN_SUCCESS,
            

        }  from '../actions/application'
import {REQUEST_INVOICE_PAYMENT, 
    RECEIVE_INVOICE_PAYMENT_SUCCESS,
    REQUEST_INVOICE_SEND,
    RECEIVE_INVOICE_SEND_SUCCESS,
    REQUEST_LOANDOCUMENT,
    RECEIVE_LOANDOCUMENT_SUCCESS,
    RECEIVE_LOANREPORT_ERROR, 
    REQUEST_INVOICE_REMINDER,
    REQUEST_REMINDER_SEND,
    RECEIVE_INVOICE_REMINDER_SUCCESS,    
    RECEIVE_REMINDER_SEND_SUCCESS
}from '../actions/loans'

const DEFAULT_LOAN_STATE =   {
    isFetching: false,
    loanRepayments: [],
    loanDocuments: []
};



export function loan(state = DEFAULT_LOAN_STATE, action) {
        switch (action.type) {
        case REQUEST_LOAN: {
            var newstate = {
                ...state,             
                isFetching: true
            };
            return newstate;
        }
        case RECEIVE_LOAN_SUCCESS: {
            var newstate = {
                ...state,   
                ...action.data.loan,
                loanRepayments: [...action.data.loanRepayments],
                loanDocuments:  [...action.data.loanDocuments],
                isFetching: false
                 }
                 
            return newstate;            
        }
        case REQUEST_INVOICE_PAYMENT: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceRequest.paymentId)
            var newState = {...state,                         
                            loanRepayments: [...state.loanRepayments],
                            loanDocuments:  [...state.loanDocuments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index], isFetching: true, fetchingStatus: 'Laskutetaan..'};
            return newState;   
        }
        case REQUEST_INVOICE_REMINDER: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceRequest.paymentId)
            var newState = {...state,                         
                            loanRepayments: [...state.loanRepayments],
                            loanDocuments:  [...state.loanDocuments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index], isFetching: true, fetchingStatus: 'Laskutetaan..'};
            return newState;   
        }

        case REQUEST_INVOICE_SEND: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceRequest.paymentId)
            var newState = {...state,                         
                            loanRepayments: [...state.loanRepayments],
                            loanDocuments:  [...state.loanDocuments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index], isFetching: true, fetchingStatus: 'Lähetetään laskua..'};
            return newState;   
        }

        case REQUEST_REMINDER_SEND: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceRequest.paymentId)
            var newState = {...state,                         
                            loanRepayments: [...state.loanRepayments],
                            loanDocuments:  [...state.loanDocuments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index], isFetching: true, fetchingStatus: 'Lähetetään maksuhuomautusta..'};
            return newState;   
        }

        case REQUEST_LOANDOCUMENT: {
            // let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceRequest.paymentId)
            // var newState = {...state,                         
            //                loanRepayments: [...state.loanRepayments]}                                                                                           
            // newState.loanRepayments[index] = {...state.loanRepayments[index], isFetching: true, fetchingStatus: 'Laskutetaan..'};
           
            var newState = {...state,                         
                    loanRepayments: [...state.loanRepayments],
                    loanDocuments:  [...state.loanDocuments],
                    isDocumentsFetching: true,
                    documentFetchingStatus: 'Muodostetaan saldotodistusta....'}

            return newState;   
        }

        case RECEIVE_LOANDOCUMENT_SUCCESS: {
            var newState = {...state,             
                            loanDocuments: [...state.loanDocuments],            
                            loanRepayments: [...state.loanRepayments, action.invoiceResponse],
                            isDocumentsFetching: false,
                            documentFetchingStatus: ''}
                                                                                                                           
            return newState;   

        }


        case RECEIVE_INVOICE_PAYMENT_SUCCESS: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceResponse.paymentId)
            var newState = {...state,             
                            loanDocuments: [...state.loanDocuments],            
                            loanRepayments: [...state.loanRepayments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index], 
                paymentInvoiceUrl: action.invoiceResponse.contractUrl, 
                invoiceToken: action.invoiceResponse.token, isFetching: false, fetchingStatus: ''};
            return newState;   
        }

        case RECEIVE_INVOICE_REMINDER_SUCCESS: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceResponse.paymentId)
            var newState = {...state,             
                            loanDocuments: [...state.loanDocuments],            
                            loanRepayments: [...state.loanRepayments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index], 
                paymentReminderUrl: action.invoiceResponse.contractUrl, 
                invoiceToken: action.invoiceResponse.token, isFetching: false, fetchingStatus: ''};
            return newState;   
        }


        case RECEIVE_INVOICE_SEND_SUCCESS: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceResponse.paymentId)
            var newState = {...state,             
                            loanDocuments: [...state.loanDocuments],            
                            loanRepayments: [...state.loanRepayments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index],
                isFetching: false, fetchingStatus: ''};
            return newState;   

        }

        case RECEIVE_REMINDER_SEND_SUCCESS: {
            let  index = state.loanRepayments.findIndex(i => i.id === action.invoiceResponse.paymentId)
            var newState = {...state,             
                            loanDocuments: [...state.loanDocuments],            
                            loanRepayments: [...state.loanRepayments]}                                                                                           
            newState.loanRepayments[index] = {...state.loanRepayments[index],
                isFetching: false, fetchingStatus: ''};
            return newState;   

        }
        
        default: {
            return state;
        }
    }
}
